import { extendDateOptions } from '@vindr/ui/src/components/ui/DateRangePicker';
import { ParamsStudyListV2, fetchStudyList } from '../apis/study.api';
import { SORT_ORDER } from './filter.constant';

export enum STUDY_LIST_ACTION_NAMES {
  VIEW = 'VIEW',
  BATCH_AI_DIAGNOSIS = 'BATCH_AI_DIAGNOSIS',
  ASSIGN_DOCTOR = 'ASSIGN_DOCTOR',
  COPY_TO_FOLDER = 'COPY_TO_FOLDER',
  BOOKMARK = 'BOOKMARK',
  SHARE = 'SHARE',
  COMPARE = 'COMPARE',
  OPEN_REPORT = 'OPEN_REPORT',
  ATTACH_FILE = 'ATTACH_FILE',
  ASSIGN_RADIOLOGIST = 'ASSIGN_RADIOLOGIST',
}

export enum STUDY_STATUS {
  UNARCHIVED,
  ARCHIVED,
}

export enum STUDYLIST_STATUS {
  NEW,
  READING,
  APPROVED,
}

export enum MATCH_STATUS {
  Unmatched,
  Matched,
}

export enum CAD_STATUS {
  NONE,
  ABNORMAL,
  NORMAL,
}

export const VIEWER_URL =
  process.env.NODE_ENV === 'production'
    ? window.config?.viewerUrl ||
      process.env.VIEWER_URL ||
      window.origin + '/viewer'
    : 'http://localhost:3000';
export const PUBLIC_VIEWER_URL = window.config?.publicViewerUrl || VIEWER_URL;

export const PUBLIC_WORKSPACE_URL =
  window.config?.publicWorkspaceUrl || window.origin;

export const MODALITIES = Object.freeze([
  'AR',
  'ASMT',
  'AU',
  'BDUS',
  'BI',
  'BMD',
  'CNC',
  'CR',
  'CT',
  'CTPROTOCOL',
  'DG',
  'DOC',
  'DR',
  'DX',
  'ECG',
  'EPS',
  'ES',
  'ESTMH',
  'FID',
  'GM',
  'HC',
  'HD',
  'IO',
  'IOL',
  'IVF',
  'IVOCT',
  'IVUS',
  'KER',
  'KO',
  'LEN',
  'LS',
  'MG',
  'MR',
  'M3D',
  'NM',
  'OAM',
  'OCT',
  'OP',
  'OPM',
  'OPT',
  'OPTBSV',
  'OPTENF',
  'OPV',
  'OSS',
  'OT',
  'PLAN',
  'PR',
  'PT',
  'PX',
  'REG',
  'RESP',
  'RF',
  'RG',
  'RTDOSE',
  'RTIMAGE',
  'RTINTENT',
  'RTPLAN',
  'RTRAD',
  'RTRECORD',
  'RTSEGANN',
  'RTSTRUCT',
  'RWV',
  'SEG',
  'SM',
  'SMR',
  'SR',
  'SRF',
  'STAIN',
  'TG',
  'TVSH',
  'US',
  'VA',
  'XA',
  'XC',
]);

export enum FOLDER_TYPE {
  ALL_STUDIES = 'ALL_STUDIES',
  DEVICES = 'DEVICES',
  PRIVATE = 'PRIVATE',
  USER_UPLOADS = 'USER_UPLOADS',
  SHARED = 'SHARED',
  BOOKMARK = 'BOOKMARK',
  ASSIGNED = 'ASSIGNED',
}

export const DOCTOR_TITLE = Object.freeze([
  'Doctor',
  'Master',
  'PhD',
  'Associate Professor',
  'Professor',
  'BSCKII.BSNT',
  'TS.BS',
]);

export const FILTER_TYPE = {
  STUDYDATE: 'study_date',
  PATIENT_ID: 'patient_id',
  PATIENT_NAME: 'patient_name',
  ORDER_GROUP: 'order_group',
  STATUS: 'studylist_status',
  INSTITUTION: 'institution_ids',
  VISIT_ID: 'visit_id',
  PATIENT_SEX: 'patient_sex',
  PATIENT_AGE: 'patient_age',
  BODY_PART: 'body_part',
  MODALITY: 'modality',
  STUDY_DESC: 'study_desc',
  MATCH_STATUS: 'match_status',
  APPROVER: 'approver',
  PROCEDURE_CODE: 'procedure_code',
  PROCEDURE_NAME: 'procedure_name',
  ORDER_DOCTOR: 'order_doctor_name',
  REFER_DOCTOR: 'refer_doctor_name',
  DIAGNOSIS: 'diagnostic',
  CAD: 'cad',
  BIRTHDAY: 'birth_date',
  PERFORMING_PHYSICIAN: 'performing_physician',
};

const [fromAllTime, toAllTime] = extendDateOptions['All Time'].map((date) =>
  date.toISOString()
);

const [fromToday, toToday] = extendDateOptions['Today'].map((date) =>
  date.toISOString()
);
export const ALLTIME_STUDYDATE = {
  study_date_from: fromAllTime,
  study_date_to: toAllTime,
};

export const INITIAL_FILTER_STUDYLIST: Pick<
  Parameters<typeof fetchStudyList>[0],
  'study_date_from' | 'study_date_to'
> = {
  study_date_from: fromToday,
  study_date_to: toToday,
};

export const INITIAL_SORTER_STUDYLIST: {
  sort_field: ParamsStudyListV2['sort_field'];
  sort_order: SORT_ORDER;
} = {
  sort_field: 'study_date',
  sort_order: SORT_ORDER.DESC,
};

export const STUDYLIST_COLUMNS_SETTING = 'col-studylist-custom';

export const STUDYLIST_COLUMNS_ORIGINAL = 'col-studylist-default';

export const SHARE_STUDY_PASSWORD_AUTO_GENERATE =
  'share-study-password-auto-generate';
